// Airwallex 配置
// 使用運行時配置（window.__APP_CONFIG__）或環境變量

declare global {
  interface Window {
    __APP_CONFIG__?: {
      AIRWALLEX_ENV?: string;
      AIRWALLEX_CLIENT_ID?: string;
    };
  }
}

export const airwallexConfig = {
  // Client ID：運行時配置 > 環境變量 > 默認值
  clientId: window.__APP_CONFIG__?.AIRWALLEX_CLIENT_ID 
    || process.env.REACT_APP_AIRWALLEX_CLIENT_ID 
    || 'CkPiqH9bTUGHQQ7h7jTcJg',
  
  // 環境：運行時配置 > 環境變量 > 默認值
  environment: (window.__APP_CONFIG__?.AIRWALLEX_ENV 
    || process.env.REACT_APP_AIRWALLEX_ENV 
    || 'demo') as 'demo' | 'staging' | 'production',
};

export default airwallexConfig;
